<template>
  <div>
    <CAlert :color="color" :show="desativado" closeButton>
      {{ msg }}
    </CAlert>
    <CCard>
      <CCardBody>
        <CButton style="width: 100px;" block color="primary"
          ><router-link
            class="router-link"
            :to="{ path: '/salas', query: { type: 'a' } }"
            >Cadastrar</router-link
          ></CButton
        >
      </CCardBody>
    </CCard>

    <CCard>
      <CCardBody
        >
        <CDataTable
          :items="salas"
          :fields="fields"
          :noItemsView="not_found"
          column-filter
          hover
          sorter
          pagination
          :items-per-page="5"
        >
          <template #acao="{ item, index }">
            <td class="py-4">
              <CButton color="primary" variant="outline" square size="sm"
                ><router-link
                  class="router-link-ver"
                  :to="{
                    path: '/salas',
                    query: { id: item.id, type: 'b' },

                    name: 'Salas',
                  }"
                  >VER</router-link
                ></CButton
              >
            </td>
            <td class="py-4">
              <CButton
                color="danger"
                variant="outline"
                square
                size="sm"
                @click="excluir(item, index)"
                >EXCLUIR</CButton
              >
            </td>
          </template>
        </CDataTable>
      </CCardBody>
    </CCard>
  </div>
</template>
<script>
export default {
  name: "ListarSalas",
  data() {
    return {
      desativado: false,
      not_found: {
        noResults: "Nenhum registro encontrado",
        noItems: "Nenhum registro encontrado",
      },
      salas: [],
      fields: [
        { key: "label", label: "Sala", _style: "min-width:200px" },
        { key: "value", label: "Andar", _style: "min-width:100px;" },

        {
          key: "acao",
          label: "",
          sorter: false,
          filter: false,
        },
      ],
      collapseDuration: 0,
      details: [],
      usuario: {
        id: localStorage.id,
        tipo: localStorage.tipo,
      },
      desativado: false,
      color: "success",
      caption: {
        type: String,
        default: "Table",
      },
    };
  },
  methods: {
    ListarSalas() {
      this.$http
        .get(`${process.env.VUE_APP_API_BASE_URL}salas`)
        .then((res) => res.json())
        .then((res) => {
          let arr = [];
          arr = res;
          arr.forEach((item) => {
            this.salas.push({
              id: item.id,
              label: `Sala:  ${item.sala}`,
              value: `Andar:  ${item.andar}º`,
            });
          });
        });
    },
    cadastrar() {
      this.$router.push("/cadastrar-salas");
    },

    editar(item) {
      this.$router.push({
        name: "Editar Sala",
        params: {
          id: item.id,
        },
      });
    },
    excluir(item, index) {
      this.$http
        .delete(
          `${process.env.VUE_APP_API_BASE_URL}salas/excluir-sala/${item.id}`
        )
        .then((res) => res.json())
        .then((res) => {
          this.desativado = true;
          this.msg = "Sala excluida com sucesso";
          this.color = "success";
          setTimeout(() => {
            this.desativado = false;
          }, 2000);
          this.ListarSalas();
        });
    },
  },

  mounted() {
    this.ListarSalas();
  },
};
</script>
<style scoped>
.pb-4,
.py-4 {
  padding: 10px !important;
}
</style>
